import { Vue, newVue } from '@/config/vue'

const init = () => {
  const Messages = Vue.component('messages', () =>
    import(/* webpackChunkName: "messages" */ './Messages.vue')
  )
  newVue({
    render: h => h(Messages),
    mount: '.js-vue-messages',
  })
}

On.VueInit({
  init({ isSpa }) {
    if (!isSpa) init()
  },
})
